import { render, staticRenderFns } from "./AddTagDropdown.vue?vue&type=template&id=1ec594c7&scoped=true"
import script from "./AddTagDropdown.vue?vue&type=script&lang=js"
export * from "./AddTagDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec594c7",
  null
  
)

export default component.exports